import { render } from "./AdvCommissionTable.vue?vue&type=template&id=79971042&scoped=true&ts=true&lang=pug"
import script from "./AdvCommissionTable.vue?vue&type=script&lang=ts"
export * from "./AdvCommissionTable.vue?vue&type=script&lang=ts"

import "./AdvCommissionTable.vue?vue&type=style&index=0&id=79971042&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79971042"]])

export default __exports__